<template>
  <a-page
    :image_source="image_source"
    :image_height="image_height"
    :color="isGroup ? '#ffffff' : '#f1f1f1'"
  >
    <template v-slot:header_options>
      <a-rms-range-selector
        v-if="!isGroup"
        ref="a-rms-range-selector"
        :event_period="[strategy_from, strategy_to]"
        @updatePeriod="updateRange"
        class="mr-2"
      >
      </a-rms-range-selector>
      <a-rms-import-dates
        v-if="!isGroup"
        ref="rms_import_dates"
      ></a-rms-import-dates>
    </template>
    <a-hotel-selector-rms
      v-if="isGroup"
      ref="a-hotel-selector-rms"
    ></a-hotel-selector-rms>
    <rms-strategy-app
      v-else
      ref="rms-strategy-app"
      :event_period="[strategy_from, strategy_to]"
    ></rms-strategy-app>
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import rmsStrategyApp from "@/components/app/default/rmsStrategyApp";
import aRmsImportDates from "@/components/rms/aRmsImportDates";
import aRmsRangeSelector from "@/components/rms/aRmsRangeSelector";
import aHotelSelectorRms from "@/components/selector/aHotelSelectorRms";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "rms-strategy",
  components: {
    aPage,
    rmsStrategyApp,
    aRmsRangeSelector,
    aHotelSelectorRms,
    aRmsImportDates
  },
  data: () => ({
    image_source: "/img/header.jpg" //Mandatory path
  }),
  methods: {
    updateRange(v) {
      let range = JSON.parse(JSON.stringify(v));
      this.strategy_from = range[0];
      this.strategy_to = range[1];
    }
  },
  computed: {
    isGroup() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    image_height() {
      return !this.isGroup ? 90 : 200;
    },
    strategy_from: {
      get() {
        return this.$store.state.rms.strategy_from;
      },
      set(value) {
        this.$store.dispatch("setStrategyFrom", value);
      }
    },
    strategy_to: {
      get() {
        return this.$store.state.rms.strategy_to;
      },
      set(value) {
        this.$store.dispatch("setStrategyTo", value);
      }
    },
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  mounted() {
    // Initialize selector
    if (!this.strategy_from) {
      this.strategy_from = Vue.moment()
        .startOf("month")
        .format("YYYY-MM-DD");
    }
    if (!this.strategy_to) {
      this.strategy_to = Vue.moment()
        .endOf("month")
        .format("YYYY-MM-DD");
    }
  }
};
</script>
